import burger from "../assets/images/notification/burger.png";
import boy from "../assets/images/notification/boy.png";
import { NotificationItem } from "../services";

interface NotifyProps {
  notifications: NotificationItem[];
  onSelect: (notification: NotificationItem) => void;
}

const isDeliveryNotification = (notification: NotificationItem) => {
  return (
    notification.category === "delivery" ||
    notification.event.includes("RIDER") ||
    notification.event.includes("PICKED_UP")
  );
};

const formatTime = (dateStr: string) => {
  return new Date(dateStr).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const Notify = ({ notifications, onSelect }: NotifyProps) => {
  if (!notifications.length) return null;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-[16px] border border-[#E9E9E9] dark:border-gray-700 overflow-hidden transition-colors duration-300">
      {notifications.map((notification, index) => {
        const isUnread = notification.readAt === null;
        const icon = isDeliveryNotification(notification) ? boy : burger;

        return (
          <div key={notification._id}>
            {index > 0 && (
              <div className="mx-3 border-t border-dashed border-[#E9E9E9] dark:border-gray-700" />
            )}
            <button
              type="button"
              onClick={() => onSelect(notification)}
              className="w-full flex justify-between items-start gap-2 p-3 md:p-4 text-left hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
            >
              <div className="flex gap-2.5 md:gap-3 items-start flex-1 min-w-0">
                <div className="relative flex-shrink-0">
                  <img
                    src={icon}
                    alt=""
                    className="h-9 w-9 md:h-10 md:w-10 aspect-square object-cover rounded-full"
                  />
                  {isUnread && (
                    <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-[#FF3B30] border-2 border-white dark:border-gray-800" />
                  )}
                </div>
                <div className="flex-1 min-w-0 pt-0.5">
                  <h6 className="text-[#050505] dark:text-white font-urbanist text-sm font-semibold leading-tight truncate">
                    {notification.title}
                  </h6>
                  <p className="text-[#6A6A6A] dark:text-gray-400 font-urbanist text-xs font-normal leading-[140%] mt-0.5 line-clamp-1">
                    {notification.message}
                  </p>
                </div>
              </div>
              <p className="flex-shrink-0 text-[#6A6A6A] dark:text-gray-400 font-urbanist text-[10px] md:text-xs font-medium leading-tight whitespace-nowrap pt-0.5">
                {formatTime(notification.createdAt)}
              </p>
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default Notify;
